import { applyStyles } from '../../utils/styleUtils';
import { useChoiceSelection } from '../../hooks/useChoiceSelection';

const SingleChoiceElement = ({ element }) => {
    const { selectedValue, handleSelect } = useChoiceSelection(element);
    const style = applyStyles(element);

    return (
        <div className="single-choice-container" style={style}>
            {element.options.map((option, index) => (
                <button
                    key={index}
                    className={`choice-option ${selectedValue === option.value ? 'selected' : ''}`}
                    onClick={() => handleSelect(option)}
                >
                    {option.text}
                </button>
            ))}
        </div>
    );
};

export default SingleChoiceElement;
